import { get, post, del } from "../../helpers/utils/http-client";
import { USERS_ENDPOINT } from "../../consts/api-endpoints";

/**
 * @typedef {Object} AccountUser
 * @property {string} email
 * @property {string} name
 * @property {string} role
 */

/**
 * Fetch the account users list.
 * @returns {Promise<AccountUser[]>}
 */
export async function getAccountUsers() {
  try {
    const { response, status } = await get(`${USERS_ENDPOINT}?p=1222`);
    if (status !== 200 || !Array.isArray(response)) {
      return [];
    }
    return response;
  } catch (err) {
    console.debug("account-users fetch failed cause", err.message, err.code);
    return [];
  }
}

/**
 * Create a new account user.
 * @param {{email: string, name: string, role: string}} request
 */
export async function createAccountUser(request) {
  try {
    return await post(`${USERS_ENDPOINT}/user-create`, request);
  } catch (err) {
    console.debug("account-user create failed cause", err.message, err.code);
    return { response: err.displayError, status: err.code };
  }
}

/**
 * Delete an account user.
 * @param {string} userId
 */
export async function deleteAccountUser(userId) {
  try {
    return await del(`${USERS_ENDPOINT}/${userId}`);
  } catch (err) {
    console.debug("account-user delete failed cause", err.message, err.code);
    return { response: err.displayError, status: err.code };
  }
}
